import React, { useContext } from 'react';
import { TranslatorContext } from '@jutro/locale';

import { StringUtil } from 'gw-portals-util-js';
import messages from './SgDirectDebitDetails.messages';

function SgDirectDebitDetails(props) {
    const {
        id,
        paymentInstrumentVM,
    } = props;

    const translator = useContext(TranslatorContext);

    return (
        <div id={`directDebitDetails_${id}`}>
            <div id={`accountHolderName_${id}`} className="sgPolicyInfo">
                <div className="sgPolicyInfoName">{translator(messages.AccountHolderName)}</div>
                <div className="sgPolicyInfoValue">{paymentInstrumentVM.value.bankAccountData.accountHolderName_Ext}</div>
            </div>
            <div id={`accountNumber_${id}`} className="sgPolicyInfo">
                <div className="sgPolicyInfoName">{translator(messages.AccountNumber)}</div>
                <div className="sgPolicyInfoValue">{paymentInstrumentVM.value.bankAccountData.bankAccountNumber}</div>
            </div>
            <div id={`sortCode_${id}`} className="sgPolicyInfo">
                <div className="sgPolicyInfoName">{translator(messages.SortCode)}</div>
                <div className="sgPolicyInfoValue">{paymentInstrumentVM.value.bankAccountData.sortCode_Ext}</div>
            </div>
            {paymentInstrumentVM.value.bankAccountData.mandateStatus_Ext && (
                <div id={`ddStatus_${id}`} className="sgPolicyInfo">
                    <div className="sgPolicyInfoName">{translator(messages.DirectDebitStatus)}</div>
                    <div className="sgPolicyInfoValue">
                        {StringUtil.capitalizeFirstLetter(paymentInstrumentVM.value.bankAccountData.mandateStatus_Ext)}
                    </div>
                </div>
            )}
        </div>
    );
}

export default SgDirectDebitDetails;
